import { Box, styled } from '@mui/material';

export const RootBox = styled(Box)(({ theme }) => ({
    padding: '128px 324px',
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.down('md')]: {
        padding: '40px 20px'
    },

    [theme.breakpoints.down('sm')]: {
        padding: '24px 16px'
    }
}));

export const ReviewButtons = styled('div')(({ theme }) => ({
    marginTop: '30px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',

    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: '12px',
        alignItems: 'stretch',
        marginTop: '24px',

        '& > *': {
            width: '100%'
        }
    }
}));
